import { Button, ButtonSize, CloseIcon } from "@bale/ui";
import React, { useState } from "react";
import { NpsForm } from "../NpsForm";
import { strings } from "intl/fa";
import styles from "./OverallNps.module.scss";

interface Props {
  onClose: () => void;
}

function OverallNps(props: Props) {
  const [score, setScore] = useState<number | undefined>();
  const [submit, setSubmit] = useState(false);

  return (
    <div className={styles.NpsCard}>
      <div className={styles.Header}>
        <CloseIcon size={24} cursor={"pointer"} onClick={props.onClose} />
        <p className={styles.Title}>{strings.nps.submit_feedback}</p>
        <p></p>
      </div>
      <div className={styles.NPSWrapper}>
        <NpsForm
          submit={submit}
          score={score}
          onScoreChange={setScore}
          onSubmit={props.onClose}
        />
      </div>
      <div className={styles.ButtonWrapper}>
        <Button
          size={ButtonSize.XLarge}
          text={strings.common.button.submit_and_continue}
          disable={score === undefined}
          onClick={() => setSubmit(true)}
        />
      </div>
    </div>
  );
}

export default OverallNps;
